/**
 * Machina Callida Backend REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Authors of curated exercises in the Machina Callida.
 */
export type ExerciseAuthor = 'callidus' | 'potsdam';

export const ExerciseAuthor = {
    Callidus: 'callidus' as ExerciseAuthor,
    Potsdam: 'potsdam' as ExerciseAuthor
};

